import messages from '@blackbox-vision/ra-language-spanish'

const filesLimit = parseInt(process.env.UPLOAD_FILES_LIMIT ?? '10')

export default {
  ...messages,
  resources: {
    invoices: {
      name: 'Adelantos de Factura',
      labelMenu: 'Adelantos',
      fields: {
        defaultSort: 'ID',
        invoiceId: 'FACTURA',
        importerName: 'COMPRADOR',
        destinationCountry: 'PAÍS',
        issuedDate: 'EMISIÓN',
        dueDate: 'VENCIMIENTO',
        invoiceAmount: 'MONTO',
        advanceAmount: 'ADELANTO',
        receivedAmount: 'MONTO RECIBIDO',
        remainingBalance: 'SALDO',
        feeAmount: 'COMISIÓN',
        cost: 'COSTO',
      },
      tabs: {
        advanced: 'AVANZADAS',
        delayed: 'ATRASADAS',
        late: 'VENCIDAS',
        paid: 'PAGADAS',
        defaulted: 'INCUMPLIDAS',
      },
      messages: {
        lateFeesDiscounted: 'cargos extra por demora aplicados',
        daysOverdueSingular: '<<delay>> día demorado.',
        daysOverduePlural: '<<delay>> días demorado.',
        delayedDetailDescriptionSingular:
          'Esta factura venció hace <b><<currentDelay>> día</b>. Haz que la abonen antes del <b><<dueDate>></b> para evitar cargos extra por demora.',
        delayedDetailDescriptionPlural:
          'Esta factura venció hace <b><<currentDelay>> días</b>. Haz que la abonen antes del <b><<dueDate>></b> para evitar cargos extra por demora.',
        lateWithoutPaymentDetailDescriptionSingular:
          'Esta factura venció hace <b><<currentDelay>> día</b>.',
        lateWithoutPaymentDetailDescriptionPlural:
          'Esta factura venció hace <b><<currentDelay>> días</b>.',
        lateWithPaymentDetailDescription:
          'Vencida el <<dueDate>>. Lleva <<currentDelay>> días de retraso. Aplican costos extra.',
        fullDetailDescriptionSingular:
          'Esta factura se pagó con <b><<delayLastPayment>> día de demorada</b>. Hemos aplicado cargos extra por demora.',
        fullDetailDescriptionPlural:
          'Esta factura se pagó con <b><<delayLastPayment>> días de demorada</b>. Hemos aplicado cargos extra por demora.',
        approvedDetailDescription: 'Pago pendiente',
        remainingBalanceRequestedHoverText:
          'Éste es un valor estimado basado en una simulación. Una vez que el adelanto sea aprobado, verá el monto final.',
        remainingBalanceApprovedHoverText:
          'La transferencia por el valor del adelanto está en curso. Una vez que quede confirmada te notificaremos.',
        advancedDescription: 'Avanzada en <<advancedDate>>',
        dueDescription: 'Vencida el <<dueDate>>',
        paidDescription: 'Pagada el <<lastPaymentDate>>',
        requestedDescription: 'Solicitada el <<createdAt>>',
        approvedDescription: 'Pago pendiente',
        onTimeStatus: 'A TIEMPO',
        delayedStatus: 'DEMORADA',
        lateStatus: 'TARDE',
        pendingStatus: 'PENDIENTE',
        pendingReviewStatus: 'EN REVISIÓN',
        paidStatus: 'PAGA',
        defaultedStatus: 'INCUMPLIDA',
        approvedStatus: 'APROBADO',
        pendingAdvanceStatus: 'PENDIENTE',
        advancedStatus: 'AVANZADO',
        invoiceNumber: 'Factura <<invoiceId>>',
        invalidDate: 'Fecha inválida',
        pastDate: 'Fecha pasada',
        notLastMonth: 'No es una fecha del último mes',
        biggerThanZero: 'El monto debe ser mayor a 0',
      },
      events: {
        date: 'Fecha',
        description: 'Descripción',
        amount: 'Monto',
        notes: 'Notas',
        invoiceIssuedDescription: 'Factura emitida',
        invoiceAdvancedDescription: 'Factura adelantada',
        invoiceRequestedDescription: 'Adelanto solicitado',
        invoiceApprovedDescription: 'Adelanto aprobado',
        collectionReceivedDescription: 'Cobranza recibida',
        invoiceSettledDescription: 'Balance pagado',
        remainingBalanceDescription: 'Saldo pendiente',
        invoiceRemainingBalancePaid: 'Saldo pendiente pagado',
        creditedInBankAccountDescription: 'Acreditado en cuenta bancaria',
        viewinvoiceAdvancedWire: 'Ver transferencia de adelanto',
        viewcollectionReceivedWire: 'Ver transferencia de cobranza',
        viewinvoiceSettledWire: 'Ver transferencia de pago',
        feesCollectedDescription: 'Costo cobrado',
        costAtRepayment: 'Costo al vencimiento',
        adjustedFeesBiggerZero: 'Costo por retraso',
        adjustedFeesLessThanZero: 'Ajuste prepago',
      },
      empty: {
        advanced: {
          noInvoices: {
            message: 'No has adelantado ninguna factura aún, ¡empieza ahora!',
            button: 'Solicita tu primer adelanto',
          },
          paidInvoices: {
            message: 'No tienes ningún adelanto pendiente por el momento.',
            button: 'Solicita tu próximo adelanto',
          },
          delayedLateInvoices: {
            message: 'Aprovecha la oportunidad de solicitar un nuevo adelanto.',
            button: 'Solicita tu próximo adelanto',
          },
        },
        delayed: {
          noInvoices: {
            message: 'No has adelantado ninguna factura aún, ¡empieza ahora!',
            button: 'Solicita tu primer adelanto',
          },
          noDelayedNoLateInvoices: {
            message: '¡Sí! ¡No tienes ninguna factura retrasada!',
          },
          noDelayedLateInvoices: {
            message:
              'No tienes ninguna factura retrasada que esté en el período de gracia.',
          },
        },
        late: {
          noInvoices: {
            message: 'No has adelantado ninguna factura aún, ¡empieza ahora!',
            button: 'Solicita tu primer adelanto',
          },
          noDelayedLateInvoices: {
            message: '¡Sí! ¡No tienes ninguna factura retrasada!',
          },
          noLateInvoices: {
            message:
              'No tienes ninguna factura tardía que esté acumulando costos extra.',
          },
        },
        paid: {
          noInvoices: {
            message: 'No has adelantado ninguna factura aún, ¡empieza ahora!',
            button: 'Solicita tu primer adelanto',
          },
          noPaidInvoices: {
            message: 'Sin facturas pagas, por el momento.',
          },
        },
      },
      actions: {
        create: {
          name: 'Adelanta tus facturas',
          nameAlt: 'Solicita el adelanto de tus facturas.',
          request: {
            title: 'Solicitud de adelanto de factura',
            subtitle:
              'Por favor, ingrese la información de la factura que desea adelantar.',
            invoiceNumber: 'Número de factura',
            buyer: 'Comprador',
            issueDate: 'Fecha de emisión',
            dueDate: 'Fecha de vencimiento',
            invoiceAmount: 'Monto de la factura',
            purchaseOrderNumber: 'Número de orden de compra',
          },
          upload: {
            title: 'Por favor, adjunta la siguiente documentación',
            button: 'Subir Archivos',
            documentation: {
              title: 'Documentación Solicitada',
              invoice: 'Factura',
              required: '(requerido)',
              proofOfDelivery: 'POD (prueba de entrega)',
              purchaseOrder: 'Orden de compra',
              proofOfAgreedDueDate: 'Prueba de fecha de vencimiento acordada',
              infoHoverText:
                'Requerido si la orden de compra no incluye la fecha de vencimiento',
              sea: 'Si utiliza transporte marítimo:',
              billOfLading: 'Bill of lading',
              insurancePolicy: 'Poliza de seguro',
            },
            uploadFileDialog: {
              title: `Puede subir hasta ${filesLimit} archivos de 50 MB cada uno`,
              text: 'Arrastra un archivo aqui o haz click',
              previewText: 'Archivos seleccionados:',
              uploadingFile: 'Subiendo ...',
              fileLimitExceedMessage:
                'Maximo numero permitido de archivos excedido. Solo {{filesLimit}} permitidos',
              fileAddedMessage:
                'El archivo {{fileName}} fue agregado exitosamente.',
              fileRemovedMessage: 'El archivo {{fileName}} fue removido.',
              dropRejectMessage:
                'El archivo {{rejectedFileName}} fue rechazado.',
              cancel: 'Cancelar',
              submit: 'Aceptar',
              close: 'Cerrar',
              uploadFile: 'Subir archivos',
              signDocument: 'Firmar Documento',
              signedDocument: 'Documento Firmado',
              signedDocumentBy: '<0>{{signer}}</0> firmó el documento',
              dismissSnackBar: 'Cerrar',
              fileUploaded: 'El archivo {{fileName}} ha sido subido',
              fileTypeError: 'Tipo de archivo no soportado',
              fileUploadError:
                'El archivo {{fileName}} no puede ser subido porque ha ocurrido un error',
              maxFilesUploaded:
                'Máximo de {{filesLimit}} documentos permitidos, por favor elimina algunos para subir más',
              maxFileSizeMessage:
                'El archivo {{fileName}} no puede ser subido porque excede el límite de tamaño de 50MB',
            },
          },
          summary: {
            title: 'Revisar adelantos a solicitar',
            subtitle: 'Facturas incluidas en la solicitud de adelanto',
            edit: 'Editar',
            uploadFiles: 'Adjuntar archivos',
            remove: 'Eliminar',
            fields: {
              buyer: 'Comprador',
              issueDate: 'Fecha de emisión',
              dueDate: 'Fecha de vencimiento',
              amount: 'Monto',
              purchaseOrder: 'Orden de compra',
              filesUploaded: 'Archivos adjuntos',
            },
          },
          response: {
            title: 'Estamos creando tu solicitud de adelanto',
            error: 'Un error ha ocurrido. Por favor, intente nuevamente',
            descriptionSingular:
              'Tu solicitud de adelanto por 1 factura está siendo creado. Esto sólo tomará unos segundos. Apenas termine podrás cerrar esta ventana y ver listados los adelantos.',
            descriptionPlural:
              'Tu solicitud de adelanto por {invoiceCount} facturas está siendo creado. Esto sólo tomará unos segundos. Apenas termine podrás cerrar esta ventana y ver listados los adelantos.',
            sign: 'El Equipo de Mundi',
          },
          submit: 'Enviar',
          finish: 'Finalizar',
          continue: 'Continuar',
          submitTooltip: 'Envía tu solicitud',
          cancel: 'Cancelar',
          next: 'Siguiente',
          back: 'Atrás',
          close: 'Cerrar',
          add: 'Agregar otra factura',
          confirmCancelTitle: 'Cancelar Adelanto',
          confirmCancelSingular:
            'Estás a punto de cancelar esta solicitud de adelanto (incluyendo 1 factura agregada). ¿Estás seguro de continuar?',
          confirmCancelPlural:
            'Estás a punto de cancelar esta solicitud de adelanto (incluyendo las {invoicesCount} facturas agregadas). ¿Estás seguro de continuar?',
          confirm: 'Salir',
          yesDiscard: 'Sí, cancela el adelanto',
          noDiscard: 'No',
          discard: 'Cancelar Adelanto',
        },
        export: {
          name: 'Exportar',
          all: 'Todos los compradores',
        },
      },
    },
    payments: {
      name: 'Pagos',
      labelMenu: 'Pagos',
      payment: {
        id: 'ID',
        date: 'FECHA',
        importerName: 'PAGADOR',
        description: 'DESCRIPCIÓN',
        amount: 'MONTO',
        notes: 'NOTAS',
      },
      events: {
        invoice: 'Factura',
        date: 'Fecha',
        description: 'Descripción',
        amount: 'Monto',
      },
      empty: {
        title:
          'Aquí encontrarás los pagos recibidos de Mundi por cualquier adelanto solicitado.',
        subtitle:
          'Podrás exportar esta información en un archivo Excel (.xlsx).',
      },
      messages: {
        advancedPaymentTransaction: 'Transferencia de pago de adelanto',
        balancePaymentTransaction: 'Transferencia de pago de saldo',
        collectionForwardTransaction: 'Transferencia de reenvío de cobranza',
        paymentCollectionDescription: 'Cobranza recibida',
        mundi: 'Mundi',
        downloadReceipt: 'Descargar comprobante',
        invoiceLinkedToEntry: 'Entradas',
        invoiceAdvance: 'Adelanto de factura',
        invoiceBalance: 'Saldo de factura',
        collectionForward: 'Reenvío de cobranza',
        invoiceSettlement: 'Pago de balance',
        invoiceCollection: 'Cobranza de factura',
        uncollectable: 'Reenvío de Cobranza',
        noInvoice: 'N/A',
      },
      actions: {
        export: {
          name: 'Exportar',
          all: 'Todas las transacciones',
          payments: 'Sólo pagos',
          error: 'No pudimos exportar el archivo, intente más tarde',
        },
      },
    },
    collections: {
      name: 'Cobranzas',
      labelMenu: 'Cobranzas',
      empty: {
        title: 'Aqui encontrarás los pagos que recibimos de tus clientes.',
        subtitle:
          'Podrás exportar esta información en un archivo Excel (.xlsx).',
      },
      actions: {
        export: {
          name: 'Exportar',
          all: 'Todas las transacciones',
          collections: 'Sólo cobranzas',
        },
      },
    },
    creditlines: {
      name: 'Lineas de crédito',
      labelMenu: 'Lineas de crédito',
      creditline: {
        id: 'ID',
        importerName: 'COMPRADOR',
        openedOn: 'ABIERTO EN',
        lineAmount: 'TAMAÑO LINEA',
        currentlyAvailable: 'DISPONIBLE',
        maxTerm: 'TÉRMINO MÁXIMO',
        maxAdvanceRate: 'TASA DE ADELANTO MÁXIMO',
        monthlyCost: 'COSTO MENSUAL',
        status: 'ESTADO',
        activeStatus: 'ACTIVO',
        openStatus: 'ABIERTO',
        closedStatus: 'CERRADO',
        gracePeriod: 'PERIODO DE GRACIA',
        currentlyAllocated: 'EN USO',
      },
      events: {
        invoice: 'FACTURA',
        issueDate: 'FECHA DE EMISIÓN',
        dueDate: 'FECHA DE VENCIMIENTO',
        inUsed: 'EN USO',
        repaidAmount: 'MONTO REPAGADO',
        empty: {
          noInvoice: {
            message:
              'Comienza a utilizar esta línea solicitando tu primer adelanto.',
            button: 'Solicita un adelanto',
          },
          table: {
            message: 'No tienes ningún adelanto pendiente por el momento.',
            button: 'Solicita tu próximo adelanto',
          },
        },
      },
      messages: {
        day: 'día',
        days: 'días',
        openedOn: 'Abierto en <<openedOn>>',
        currentlyAllocated: 'En uso',
        currentlyAdvancedInvoices: 'Facturas Actualmente Adelantadas (<<N>>)',
        invoiceHistory: 'Historia de facturas (<<N>>)',
        totalUsed: 'Total utilizado',
      },
      empty: 'No tienes ninguna linea de crédito aún',
    },
  },
  account: {
    login: {
      title: 'Iniciar sesión',
      email: 'Correo Electrónico',
      emailError: 'Ingrese una dirección de correo electrónico válida',
      password: 'Contraseña',
      passwordError: 'Ingrese una contraseña válida',
      button: 'Ingresar',
      loginErrorTitle: 'Error en inicio de sesión',
      loginErrorBody:
        'La dirección de correo electrónico y/o la contraseña ingresada no son válidos. Por favor, intente nuevamente.',
      passwordVisibility: 'Cambia la visibilidad de la contraseña',
    },
    activation: {
      title: 'Active su cuenta',
      passwordConfirmation: 'Confirme la contraseña ingresada',
      passwordConfirmationError: 'Las contraseñas ingresadas no coinciden',
      button: 'Activar',
    },
    verification: {
      successTitle: 'Correo electrónico verificado',
      successBody:
        '¡Su correo electrónico fue verificado con éxito!\nEn las próximas 24 horas, el representante de su cuenta se comunicará con usted para finalizar el proceso de registro.\n\n¡Bienvenido a Mundi!\n\n- El equipo de Mundi',
    },
  },
  notFound: {
    title: 'Ups! Página no encontrada',
    subtitle:
      'Aparentemente la página a la que estás intentando ingresar no existe o está momentáneamente no disponible.',
    button: 'Volver a Mundi',
  },
}
